import { Throbber } from 'app/components/throbber';
import { useI18n } from 'core/hooks/useI18n';
import { Routing } from 'core/routing/Routing';
import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

const ResourceGroups = lazy(() => import('./configuration/pages/permission/resource-groups/ResourceGroups'));
const ResourceGroupForm = lazy(
  () => import('./configuration/pages/permission/resource-groups/components/forms/ResourceGroupForm')
);
const ResourceGroupDetailsForm = lazy(
  () =>
    import(
      './configuration/pages/permission/resource-groups/components/forms/resource-group-details-form/ResourceGroupDetailsForm'
    )
);
const ResourceGroupMonitoringForm = lazy(
  () =>
    import(
      './configuration/pages/permission/resource-groups/components/forms/resource-group-monitoring-form/ResourceGroupMontioringForm'
    )
);

export function ResourceGroupsRoutes() {
  const { l10n } = useI18n('app');
  return (
    <Route
      path={Routing.routes.configuration.permission.resourceGroups.root}
      element={
        <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
          <ResourceGroups />
        </Suspense>
      }
    >
      <Route
        path={Routing.routes.configuration.permission.resourceGroups.create.root}
        element={
          <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
            <ResourceGroupForm />
          </Suspense>
        }
      >
        <Route
          path={Routing.routes.configuration.permission.resourceGroups.create.details()}
          element={
            <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
              <ResourceGroupDetailsForm />
            </Suspense>
          }
        />
        <Route
          path={Routing.routes.configuration.permission.resourceGroups.create.monitoring()}
          element={
            <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
              <ResourceGroupMonitoringForm />
            </Suspense>
          }
        />
      </Route>
      <Route
        path={Routing.routes.configuration.permission.resourceGroups.createPublic.root}
        element={
          <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
            <ResourceGroupForm />
          </Suspense>
        }
      >
        <Route
          path={Routing.routes.configuration.permission.resourceGroups.createPublic.details()}
          element={
            <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
              <ResourceGroupDetailsForm />
            </Suspense>
          }
        />
        <Route
          path={Routing.routes.configuration.permission.resourceGroups.createPublic.monitoring()}
          element={
            <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
              <ResourceGroupMonitoringForm />
            </Suspense>
          }
        />
      </Route>
      <Route
        path={Routing.routes.configuration.permission.resourceGroups.edit.root}
        element={
          <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
            <ResourceGroupForm />
          </Suspense>
        }
      >
        <Route
          path={Routing.routes.configuration.permission.resourceGroups.edit.details()}
          element={
            <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
              <ResourceGroupDetailsForm />
            </Suspense>
          }
        />
        <Route
          path={Routing.routes.configuration.permission.resourceGroups.edit.monitoring()}
          element={
            <Suspense fallback={<Throbber>{l10n('loading.screen.siteConfiguration')}</Throbber>}>
              <ResourceGroupMonitoringForm />
            </Suspense>
          }
        />
      </Route>
    </Route>
  );
}
